import {SagaIterator} from 'redux-saga';
import Store from 'store';
import {FULFILLED} from 'redux-promise-middleware';

import {CUSTOMER} from 'constants/actions';
import {IRE_CLICK_ID} from 'constants/analytics/storages';
import {CONVERSION_TRACKING_ID_EMAIL_LEAD} from 'constants/analytics/impactRadius';

import {takeEvery, select, call, take, cancel} from 'redux-saga/effects';

import {generateClickId} from 'sagas/analytics/impactRadius/clickId';
import {getCustomer} from 'selectors/customer/customer';
import {doTransform} from 'libs/transformers';
import flags from 'constants/flags/flags';

type TrackConversionDataType = {
    orderId: string;
    clickid: string;
    customerId: string;
    customerStatus?: string;
    currencyCode?: string;
    customerEmail?: string;
    orderPromoCode?: string;
    email?: string;
    items?: Array<{
        category: string;
        quantity: number;
        sku: string;
        subTotal: number;
    }>;
};

/**
 * Track conversion.
 *
 * @param {TrackConversionDataType} data - Data for track conversion.
 * @param {string} id - ID for IR.
 */
export function* trackConversion(data: TrackConversionDataType, id: string | number) {
    try {
        if (!flags.impactSendConversion.isEnabled()) yield cancel();
        if (window.ire) yield call(window.ire, 'trackConversion', id, data);
    } catch (error) {
        yield call([console, 'log'], error);
    }
}

/**
 * Preparation data for conversion tracking for email lead.
 *
 * @param {string} email - Customer email.
 */
export function* preparationDataForTrackConversionEmailLead(email: string): SagaIterator {
    yield call(generateClickId);
    const clickid = yield call([Store, 'get'], IRE_CLICK_ID);
    const hashedEmail = yield call(doTransform, email, 'sha1');
    const {sid} = yield select(getCustomer);
    yield call(
        trackConversion,
        {
            orderId: sid || '',
            clickid,
            customerId: hashedEmail,
            email: hashedEmail,
        },
        CONVERSION_TRACKING_ID_EMAIL_LEAD,
    );
}

/**
 * Tracking the client after registration.
 */
export function* trackingCustomerAfterReload(): SagaIterator {
    yield take(`${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`);
    const {email} = yield select(getCustomer);
    yield call(preparationDataForTrackConversionEmailLead, email);
}

/**
 * Begin of saga.
 */
export default function* track() {
    yield takeEvery(`${CUSTOMER.SEND_REGISTRATION}_${FULFILLED}`, trackingCustomerAfterReload);
}
